import { palette } from './palette';
import { createTypographyVariants } from 'hx-util';
export var typography = {
    styleOverrides: {
        root: {
            marginInline: 'auto',
            textAlign: 'center',
            fontFamily: 'Roboto',
            color: palette.text.primary,
        },
    },
    variants: createTypographyVariants({
        h1: {
            fontSize: '1.9375rem',
            textTransform: 'uppercase',
            fontWeight: '600',
            letterSpacing: '0.2rem',
            color: palette.text.primary,
        },
        h2: {
            fontSize: '1.5rem',
            fontWeight: '500',
        },
        h5: {
            fontSize: '1rem',
            fontWeight: '900',
        },
        h6: {
            fontSize: '0.6875rem',
            fontWeight: '900',
        },
        subhead: {
            fontSize: '0.75rem',
            fontWeight: '600',
            color: palette.text.primary,
        },
        body1: {
            fontSize: '1rem',
            fontWeight: 'inherit',
        },
        'body-small': {
            fontSize: '0.9rem',
            fontWeight: 'inherit',
        },
        body2: {
            textAlign: 'left',
            fontSize: '0.675rem',
        },
        info: {
            fontSize: '0.9rem',
            textDecoration: 'none',
        },
        small: {
            fontSize: '0.5625rem',
            color: palette.text.primary,
        },
        disclaimer: {
            fontSize: '0.4375rem',
            textAlign: 'left',
            fontStyle: 'italic',
            fontWeight: '100',
            lineHeight: '0.625rem',
        },
        'disclaimer-link': {
            fontSize: '0.4375rem',
            textAlign: 'left',
            fontStyle: 'italic',
            color: palette.text.primary + ' !important',
            textDecorationColor: palette.text.primary + ' !important',
            fontWeight: '100',
        },
        list: {
            fontSize: '0.4375rem',
        },
        'subhead-bold': {
            fontSize: '0.875rem',
            fontWeight: '900',
        },
        link: {
            fontSize: '0.75rem',
            color: palette.text.primary,
        },
    }),
};
